import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ajaxGet, ajaxGetType } from '../../common/ajax';

export const CONFIG_APPLICATIONS = {
    AVA: 'AVA',
};

export const CONFIG_FEATURE_FLAGS = {
    ENABLE_CAW_STATUS_CHANGE: 'EnableCawStatusChange',
};

export const isFeatureFlagActive = (responseOrFlags, featureFlagName) => {
    const flags = Array.isArray(responseOrFlags) ? responseOrFlags : responseOrFlags?.response?.featureFlags;

    if (!Array.isArray(flags)) {
        return false;
    }

    return flags.some(
        (flag) => (flag?.name || flag?.Name) === featureFlagName && (flag?.isActive ?? flag?.IsActive ?? false),
    );
};

const configurationService = {
    getFeatureFlags$: (id) => ajaxGet(`api/config/GetFeatureFlags/${id}`),

    getFeatureFlagsByName$: (name) => ajaxGet(`api/config/GetFeatureFlagsByName/${name}`),

    getAppSetting$: (id) => ajaxGetType(`api/config/GetConfig/${id}`, 'text'),

    getUiFeatureFlags$: () => ajaxGetType(`api/config/GetUiFlags`, 'json'),

    getCawStatusChangeEnabled$: () =>
        configurationService.getFeatureFlagsByName$(CONFIG_APPLICATIONS.AVA).pipe(
            map((response) => isFeatureFlagActive(response, CONFIG_FEATURE_FLAGS.ENABLE_CAW_STATUS_CHANGE)),
            catchError((error) => {
                console.error(error);
                return of(false);
            }),
        ),

    getAESetting$: (variableKey) => ajaxGet(`api/config/GetAESetting/${variableKey}`),

    getAminFlags$: () => ajaxGet(`api/admin/applications/`),

    getUMSetting$: (variableKey) => ajaxGet(`api/um/settings/${variableKey}`),

    getCMUMSetting$: (variableKey) => ajaxGet(`api/cmauth/settings/${variableKey}`),

    getFacetsProviderId$: (key) => ajaxGetType(`api/config/GetFacetsProviderId/${key}`, 'text'),

    getReadonlyAuthSources$: () => ajaxGetType(`api/config/GetReadonlyAuthSources`, 'json'),

    getDefaultProviderIds$: () => ajaxGetType(`api/config/GetDefaultProviderIds`, 'json'),
};

export { configurationService };
